const CONTACT_EMAIL = 'info@phoenixunitydesigns.com'
const testimonials = [
  {
    quote: 'Mia is incredibly attentive and patient. She redesigned the entire aesthetic of our website with so much care, really taking into account my vision and the flow I wanted. She also took initiative to create sections that were missing, which added valuable content and depth to the site. She is always available to make changes quickly, and her photography skills are excellent. I\'m very grateful we chose her to help revamp our online presence.',
    author: 'Veronica Allenger (Time For You Electrolysis)',
  },
  {
    quote: 'Collaborating with Mia is always a pleasure. Her deep knowledge and understanding of web design and development has always led my projects to success. I\'m looking forward to working with her again in the future.',
    author: 'Jeff Jenkins',
  },
  {
    quote: 'I was extremely pleased with the website and had nothing but positive feedback. In working with Mia Petrasovic, it was evident that she had a strong work ethic and did everything in her power to accommodate all requests and answer questions as needed. I would have no hesitation in referring her services to family, friends and colleagues.',
    author: 'Ida Settino',
  },
  {
    quote: 'Mia\'s experience and expertise produced a website for us that far exceeded all of our expectations.',
    author: 'Mathew Tasson',
  }
]

export {
  CONTACT_EMAIL,
  testimonials,
}